import React from "react";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import HeaderSearchBar from "core/SearchBar/variations/HeaderSearchBar";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const SearchBarStyled = styled.div`
    position: absolute;
    z-index: 1;
    top: 0rem;

    ${({ $styleProps: { left, right } }) => {
        return css`
            transition:
                left ${left.speed}ms ease ${left.delay}ms,
                right ${right.speed}ms ease ${right.delay}ms;
            left: ${convertPxToRem(left.value)};
            right: ${convertPxToRem(right.value)};
        `;
    }}
`;

// Holds the Search Bar
export const SearchBar = () => {
    const {
        isDarkMode,
        isCompact,
        animation: { styleProps, isSingleRowStart },
    } = useSiteHeader();

    return (
        <SearchBarStyled $styleProps={styleProps}>
            <HeaderSearchBar
                id="header-search-tablet-desktop"
                isDarkMode={isDarkMode}
                // Row 2's search bar is only ever truly hidden on SRS pages
                // (home/icons-landing/photos-landing) before it's revealed -
                // on DRS pages it's always visible, so it should never be
                // excluded from the tab order there.
                isDisabled={isSingleRowStart && !isCompact}
            />
        </SearchBarStyled>
    );
};

export default SearchBar;
